import React from "react";
import { API } from "@/lib/api";
import { X } from "lucide-react";

const WA_NUMBER = "6282114294101";
const DURATION_MS = 30000; // one full scroll cycle (adjust via CSS too)

/**
 * Thin marquee bar above the header. Shows published posters flagged
 * `tampil_rolling=true`. Each item is a WhatsApp CTA chip.
 * Section auto-hidden if nothing qualifies.
 */
export default function RollingAdBar() {
  const [items, setItems] = React.useState([]);
  const [hidden, setHidden] = React.useState(false);

  React.useEffect(() => {
    if (sessionStorage.getItem("batik_rolling_closed") === "1") {
      setHidden(true);
      return;
    }
    fetch(`${API}/posters`, { credentials: "omit" })
      .then((r) => (r.ok ? r.json() : []))
      .then((data) => {
        const rolling = (Array.isArray(data) ? data : []).filter((p) => p.tampil_rolling);
        setItems(rolling);
      })
      .catch(() => setItems([]));
  }, []);

  if (hidden || items.length === 0) return null;

  // Duplicate once for seamless infinite scroll
  const loop = [...items, ...items];

  const waUrl = (p) =>
    `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(
      `Assalamu'alaikum, saya tertarik dengan ${p.judul}`
    )}`;

  return (
    <div
      className="w-full bg-primary text-primary-foreground border-b border-accent/30 overflow-hidden relative"
      data-testid="rolling-ad-bar"
    >
      <div className="flex items-center">
        <span className="hidden sm:inline-flex items-center gap-2 bg-accent text-primary text-[11px] font-semibold uppercase tracking-widest px-3 py-1.5 flex-shrink-0">
          Promo
        </span>

        <div className="flex-1 overflow-hidden relative py-1.5">
          <div
            className="flex gap-10 whitespace-nowrap will-change-transform"
            style={{
              animation: `batik-marquee ${DURATION_MS}ms linear infinite`,
              width: "max-content",
            }}
          >
            {loop.map((p, i) => (
              <a
                key={`${p.id}-${i}`}
                href={waUrl(p)}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm hover:text-accent transition-colors"
                data-testid={i < items.length ? `rolling-item-${p.id}` : undefined}
              >
                <span className="text-accent">◆</span>
                <span>{p.judul}</span>
                {p.deskripsi && (
                  <span className="text-primary-foreground/60">— {p.deskripsi.slice(0, 80)}</span>
                )}
              </a>
            ))}
          </div>
        </div>

        <button
          type="button"
          onClick={() => {
            sessionStorage.setItem("batik_rolling_closed", "1");
            setHidden(true);
          }}
          className="flex-shrink-0 p-2 text-primary-foreground/70 hover:text-primary-foreground"
          aria-label="Tutup bar promo"
          data-testid="rolling-close"
        >
          <X className="h-4 w-4" />
        </button>
      </div>

      <style>{`
        @keyframes batik-marquee {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}
